import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

const lerp = (a, b, n) => (1 - n) * a + n * b;

export default class CuttingEdge extends Component {
	constructor() {
		super({
			element: '.vision',
			elements: {
				original: '.ce-original',
			},
		});

		this.progress = { p: 0 };
	}

	create() {
		super.createComponent();
		if (!this.elements.original) return;

		this.tl?.kill();

		const original = this.elements.original;
		const topPaths = original.querySelectorAll('.ce-top path');
		this.p2 = topPaths[0];
		this.p3 = topPaths[1];
		this.bottom = original.querySelector('.ce-bottom');

		// Make sure the original top is in its initial triangle before cloning.
		this.progress.p = 0;
		this.drawTop();

		// Opaque full-composition clone, parked one height above the frame.
		const svg = original.parentNode;
		const old = svg.querySelector('.ce-clone');
		if (old) old.remove();
		this.clone = original.cloneNode(true);
		this.clone.setAttribute('class', 'ce-clone');
		svg.appendChild(this.clone);
		GSAP.set(this.clone, { y: -440 });

		// Phase 1 — the top morphs its center point straight down (the "knife"
		//   dropping, top edges/sides stay put) while the bottom shapes fall off.
		// Phase 2 — the opaque clone slides down from above into the initial layout.
		// Swap — original snaps back; clone parks above. Identical → invisible.
		this.tl = GSAP.timeline({ repeat: -1, repeatDelay: 1 });

		this.tl.to(
			this.progress,
			{ p: 1, duration: 1.2, ease: 'power2.in', onUpdate: () => this.drawTop() },
			0
		);
		this.tl.to(this.bottom, { y: 440, duration: 1.2, ease: 'power2.in' }, 0);

		this.tl.to(this.clone, { y: 0, duration: 4.5, ease: 'expo.out' });

		this.tl.add(() => {
			this.progress.p = 0;
			this.drawTop();
		});
		this.tl.set(this.bottom, { y: 0 });
		this.tl.set(this.clone, { y: -440 });
	}

	// p: 0 = initial triangle, 1 = full-height rectangle.
	drawTop() {
		const p = this.progress.p;
		const bottomY = lerp(290, 440, p);
		const sideY = lerp(154, 440, p);

		this.p2.setAttribute(
			'd',
			`M10 0H136V${bottomY}L0 ${sideY}V10C0 4.47715 4.47715 0 10 0Z`
		);
		this.p3.setAttribute(
			'd',
			`M262 0H136V${bottomY}L272 ${sideY}V10C272 4.47715 267.523 0 262 0Z`
		);
	}

	destroy() {
		this.tl?.kill();
		this.clone?.remove();
		super.destroy();
	}
}
